<template>
	<page-content-layout class="vehicle-list" title="Vehicles">
		<button-group-view slot="tools" :actions="[
			{
				label: 'Aktive',
				value: 'active'
			},
			{
				label: 'Planlægning',
				value: 'planning'
			},
			{
				label: 'Tracking',
				value: 'tracking'
			},
			{
				label: 'Inaktive',
				value: 'inactive'
			}
		]" v-model="filter" />
		<button-view slot="tools" label="Opret" @click="createButtonClick" />
		<new-table-view ref="table" :columns="[
			{
				label: 'Navn',
				name: 'name'
			},
			{
				label: 'Registreringsnummer',
				name: 'reg_no'
			},
			{
				label: 'Mærke',
				name: 'make'
			},
			{
				label: 'Model',
				name: 'model'
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: 'Slet'
				}
			}
		]" :items="_items" @itemClick="itemClick" @delete="itemDelete" @action="action" :actions="actions" />
	</page-content-layout>
</template>

<script>
	import Window from '../windows/VehicleWindow'
	import NewTableView from '../views/NewTableView'

	import { bus } from '../../bus'

    export default {
		props: [],
		components: {
			newTableView: NewTableView
		},
		computed: {
			_items() {
				var r = [];

				if (this.items === null) return null;

				for (var i = 0; i < this.items.length; ++i) {
					var item = this.items[i];

					if (this.filter == 'active' && (item.planning || item.tracking)) r.push(item); 
					if (this.filter == 'planning' && item.planning) r.push(item); 
					if (this.filter == 'tracking' && item.tracking) r.push(item); 
					if (this.filter == 'inactive' && (!item.planning && !item.tracking)) r.push(item); 
				}

				return r;
			}
		},
		methods: {
			createButtonClick: function () {
				var contacts = this;

				this.$store.state.windowStack.push(Window, {
					onChange: function (ent) {
						
						

						contacts.update();
					}
				});
			},
			itemClick: function (item) {
				var contacts = this;

				this.$store.state.windowStack.push(Window, {id: item.id, form: true, onChange: function () {
					contacts.update();
				}});
			},
			itemDelete(item) {
				if (!confirm('Sikker?')) return;

				var view = this;

				this.axios
					.delete('/fleet/vehicles/' + item.id + '/')
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							view.update();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			action: function (name, id) {
				if (name == 'delete' && confirm('Sure?')) {
					

					var contacts = this;

					this.axios
						.delete('/fleet/vehicles/' + id + '/')
						.then(function () {
							contacts.update();
						}, function () {
							alert('Could not delete the item');
						});
				}
			},
			update() {
				var contacts = this;

				contacts.items = null;

				this.axios
					.get('/fleet/vehicles/')
					.then(function (r) {
						
						contacts.items = r.data._items;
					});
			}
		},
		data: function () {
			return {
				items: [],
				columns: [],
				actions: [
					{name: 'delete', label: 'Delete'}
				],
				filter: 'active'
			};
		},
		mounted: function () {
			this.axios.put('/activity/vehicles/');

			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				
			});


			/*this.axios
				.all([
					this.axios.get('/contacts/'),
					this.axios.get('/contacts/columns/')
				]).then(function (results) {
					
				});*/
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss">

</style>